import React, { useState, useMemo } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css"; 

function VendorApproved() {
  const [vendors] = useState([
    {
      id: 1,
      name: "TechStore Pvt Ltd",
      email: "contact@techstore.com",
      phone: "+91 9876543210",
      category: "Electronics",
      approvedOn: "2025-08-15",
      status: "Approved",
      createdAt: "2025-07-01",
      logo: "https://via.placeholder.com/60",
    },
    {
      id: 2,
      name: "FitGear",
      email: "support@fitgear.com",
      phone: "+91 9123456780",
      category: "Footwear",
      approvedOn: "2025-08-20",
      status: "Approved",
      createdAt: "2025-06-25",
      logo: "https://via.placeholder.com/60",
    },
    {
      id: 3,
      name: "HomeEssentials",
      email: "hello@homeessentials.com",
      phone: "+91 9988776655",
      category: "Home & Kitchen",
      approvedOn: "2025-08-22",
      status: "Pending",
      createdAt: "2025-07-05",
      logo: "https://via.placeholder.com/60",
    },
  ]);

  const [filters, setFilters] = useState({
    search: "",
    category: "All",
    status: "All",
    dateFrom: null,
    dateTo: null,
  });

  const [showFilter, setShowFilter] = useState(false);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleDateChange = (name, date) => {
    setFilters({ ...filters, [name]: date[0] });
  };

  const filteredVendors = useMemo(() => {
    return vendors.filter((v) => {
      const matchesSearch =
        v.name.toLowerCase().includes(filters.search.toLowerCase()) ||
        v.email.toLowerCase().includes(filters.search.toLowerCase()) ||
        v.phone.toLowerCase().includes(filters.search.toLowerCase());

      const matchesCategory =
        filters.category === "All" || v.category === filters.category;

      const matchesStatus =
        filters.status === "All" || v.status === filters.status;

      const matchesDate =
        (!filters.dateFrom || new Date(v.approvedOn) >= filters.dateFrom) &&
        (!filters.dateTo || new Date(v.approvedOn) <= filters.dateTo);

      return matchesSearch && matchesCategory && matchesStatus && matchesDate;
    });
  }, [vendors, filters]);

  const categories = ["All", ...new Set(vendors.map((v) => v.category))];

  return (
    <>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="main-content">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="breadcrumb-title">Approved Vendors</h4>
            <button
              className="btn btn-primary"
              onClick={() => setShowFilter(true)}
            >
              Filters
            </button>
          </div>

          <div className="col-12">
            <div className="card shadow-sm border-0">
              <div className="card-body table-responsive">
                <table className="table table-hover table-striped align-middle">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Logo</th>
                      <th>Vendor Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Category</th>
                      <th>Approved On</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredVendors.map((v) => (
                      <tr key={v.id}>
                        <td>{v.id}</td>
                        <td>
                          <img
                            src={v.logo}
                            alt={v.name}
                            className="rounded"
                            style={{ width: "60px", height: "60px", objectFit: "cover" }}
                          />
                        </td>
                        <td>{v.name}</td>
                        <td>{v.email}</td>
                        <td>{v.phone}</td>
                        <td>{v.category}</td>
                        <td>{v.approvedOn}</td>
                        <td>
                          <span
                            className={`badge ${
                              v.status === "Approved" ? "bg-success" : "bg-warning"
                            }`}
                          >
                            {v.status}
                          </span>
                        </td>
                        <td>{v.createdAt}</td>
                        <td>
                          <div className="d-flex gap-1">
                            <button className="btn btn-sm btn-primary">View</button>
                            <button className="btn btn-sm btn-danger">Reject</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Custom Filter Panel */}
          <div className={`filter-panel ${showFilter ? "open" : ""}`}>
            <div className="filter-header">
              <h5>Filters</h5>
              <button className="btn-close" onClick={() => setShowFilter(false)}></button>
            </div>
            <div className="filter-body">
              <div className="mb-3">
                <label>Search</label>
                <input
                  type="text"
                  className="form-control"
                  name="search"
                  placeholder="Vendor name, email or phone"
                  value={filters.search}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="mb-3">
                <label>Category</label>
                <select
                  className="form-control"
                  name="category"
                  value={filters.category}
                  onChange={handleFilterChange}
                >
                  {categories.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label>Status</label>
                <select
                  className="form-control"
                  name="status"
                  value={filters.status}
                  onChange={handleFilterChange}
                >
                  <option value="All">All</option>
                  <option value="Approved">Approved</option>
                  <option value="Pending">Pending</option>
                </select>
              </div>
              <div className="mb-3">
                <label>Approved From</label>
                <Flatpickr
                  value={filters.dateFrom}
                  onChange={(date) => handleDateChange("dateFrom", date)}
                  options={{ dateFormat: "Y-m-d" }}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <label>Approved To</label>
                <Flatpickr
                  value={filters.dateTo}
                  onChange={(date) => handleDateChange("dateTo", date)}
                  options={{ dateFormat: "Y-m-d" }}
                  className="form-control"
                />
              </div>
              <button className="btn btn-primary w-100" onClick={() => setShowFilter(false)}>
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default VendorApproved;
